/**
 * Pure display formatters. No DOM, no atoms - trivially
 * unit-testable. `formatBytes` is the blob's exact byte→human ladder, reused by
 * the export stats strip and the download "Exported N" readout.
 */

/** Human-readable byte size - B / KB / MB / GB, matching the blob's thresholds. */
export function formatBytes(b: number): string {
  if (b < 1024) return b + ' B';
  if (b < 1024 * 1024) return (b / 1024).toFixed(1) + ' KB';
  if (b < 1024 * 1024 * 1024) return (b / (1024 * 1024)).toFixed(1) + ' MB';
  return (b / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
}
